import React, { Component } from 'react';  
import { hashHistory } from 'react-router';

import Util from "../../util.js"
import 'zrender/lib/svg/svg';
import echarts from 'echarts/lib/echarts';
// 引入柱状图
// import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/legend';
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import ModalList from "../Modal/ModalList";

import { getHistoryAdjust, getFindAssetConfig  } from '../../action/investmentAction';


// let problemList = { 
//   content:{
//     "total":4,
//     "rows":[
//       {
//         "content":"一分钟了解华夏智投",
//         "title":"<p>华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。</p>\n<p>华夏智投组合为客户提供教育金智投、时光智投和资产增值智投三个系列，共9个组合，可以满足客户资产增值、教育、养老等多方面的投资需求，客户可以根据自身需要，选择不同的智投组合。</p>\n","bq":[{"tagName":"智投介绍","cjwtId":1493,"tagId":"WT_TAG_1492"}],"orderFlag":1,"NUM":1,"pageValid":"1","key":1493
//       },
//       {
//         "content":"查理机器人介绍",
//         "title":"<p>查理是汇聚华夏基金多年丰富的主动资产管理和海外资产配置经验，为您精心打造的智投机器人，查理将利用互联网技术与AI智能算法，为客户提供财务目标规划、生成资产配置解决方案、组合全周期管理的一站式智投服务，让每个客户都享受到私人银行般的服务。</p>\n","bq":[{"tagName":"智投介绍","cjwtId":1596,"tagId":"WT_TAG_1492"}],"orderFlag":2,"NUM":2,"pageValid":"1","key":1596
//       },
//       {
//         "content":"创建智投组合的方式",
//         "title":"<p>您只需要两步就能创建属于您的智投组合：</p>\n<p>1、华夏智投包括教育、养老和资产增值三种场景，您可以根据自身需要选择智投组合。您也可以通过智投计算器来测算一下，获得推荐组合和投资方案；</p>\n<p>2、 进入智投组合详情页后，只需要点击“一键投资”按钮，完成支付即可。购买组合一般需要两天的时间，购买后请随时关注组合调仓情况，及时跟踪调仓。</p>\n<p></p>\n","bq":[{"tagName":"智投介绍","cjwtId":1495,"tagId":"WT_TAG_1492"}],"orderFlag":3,"NUM":3,"pageValid":"1","key":1495
//       },
//       {
//         "content":"智投计算器有什么用？",
//         "title":"<p>智投计算器是帮助客户根据目前的所处阶段（例如客户年龄、当前养老储备金、预期每年养老金需求，或者孩子年龄、当前教育储备金等），计算客户养老金或者教育金缺口及所需投资金额。</p>\n","bq":[{"tagName":"智投介绍","cjwtId":1771,"tagId":"WT_TAG_1492"}],"orderFlag":4,"NUM":4,"pageValid":"1","key":1771
//       }
//     ]
//   }
// }



let allData = [
  {
    fundCode:"002229",
    fundName:"华夏经济转型股票11111",
    fundType:"0",
    regularRate:"0.0998",
    styleType:"1",
    styleTypeName:"国内权益基金"
  },
  {
    fundCode:"002891",
    fundName:"华夏移动互联混合（QDII）",
    fundType:"8",
    regularRate:"0.1044",
    styleType:"1",
    styleTypeName:"国内权益基金"
  },
  {
    fundCode:"002460",
    fundName:"华夏鼎利债券C",
    fundType:"1",
    regularRate:"0.0998",
    styleType:"1",
    styleTypeName:"国内债券基金"
  },
  {
    fundCode:"003003",
    fundName:"华夏现金增利货币A",
    fundType:"2",
    regularRate:"0.1011",
    styleType:"5",
    styleTypeName:"货币基金"
  },
  {
    fundCode:"160314",
    fundName:"华夏行业混合",
    fundType:"0",
    regularRate:"0.2002",
    styleType:"1",
    styleTypeName:"国内权益基金"
  },
  {
    fundCode:"001928",
    fundName:"华夏消费升级混合C",
    fundType:"0",
    regularRate:"0.1481",
    styleType:"1",
    styleTypeName:"国内权益基金"
  },
  {
    fundCode:"002230",
    fundName:"华夏大中华混合(QDII)",
    fundType:"8",
    regularRate:"0.1446",
    styleType:"2",
    styleTypeName:"跨境权益基金"
  },
  {
    fundCode:"001033",
    fundName:"华夏安康债券C",
    fundType:"1",
    regularRate:"0.102",
    styleType:"3",
    styleTypeName:"国内债券基金"
  },
]

let width = window.screen.width 



export class SuperPie extends Component {
    shouldComponentUpdate(nextProps = {}, nextState = {}) {
        const thisProps = this.props || {}, thisState = this.state || {};
        for (const key in nextProps) {
          if (thisProps[key] !== nextProps[key] ) {
            return true;
          }
        }

        for (const key in nextState) {
          if (thisState[key] !== nextState[key] ) {
            return true;
          }
        }
        
        return false;
    }
    componentDidMount() {
      let { data, dataName } = this.props;
      console.log( data, dataName )
      // 基于准备好的dom，初始化echarts实例
      
      if (window.isLess47) {
        var myChart = echarts.init(document.getElementById('SuperPie'));
      }else{
        var myChart = echarts.init(document.getElementById('SuperPie'), null, {renderer: 'svg'});
      }
      myChart.clear();
      // 绘制图表
      myChart.setOption(SuperPieOption(data,dataName));
    }
    componentWillReceiveProps(nextProps) {
      if(JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
        if (window.isLess47) {
          var myChart = echarts.init(document.getElementById('SuperPie'));
        }else{
          var myChart = echarts.init(document.getElementById('SuperPie'), null, {renderer: 'svg'});
        }
        
      // 绘制图表
        myChart.clear();
        myChart.setOption(SuperPieOption(nextProps.data,nextProps.dataName));
      }
    }
    componentWillUnmount(){
      var myChart = echarts.init(document.getElementById('SuperPie'));
      myChart.clear();
    }
    render() {
        let { pieImg } = this.props;
        console.log(pieImg,"pieImgpieImgpieImgpieImgpieImg")

        return (
          <div style={{ background:"#FFF",position:'relative',width:"100%", height:240,}}>
            {/*
            <div style={{ position:'absolute', left:0, top:0, zIndex:98, height:"100%", width:'100%'}}>
              <div style={{ width:64, height:64, position:'absolute', left:width*0.3-32, top:120-32}}>
                <div style={{ background: pieImg ? pieImg :`url(${require("../../img/60Pie.png")})`,backgroundSize:'cover', width:64, height:64}}>
                  
                </div>
              </div>
            </div>*/}
            <div id="SuperPie" style={{ width:"100%", height:240, }}></div>
          </div>
        );
    }
}

export class FundList extends Component{
  constructor(props) {
    super(props);
    this.state = {};
  }
  render(){
    let data = this.props.data;
    let colorArr = [];
    data.map((item,key)=>{
      if(item.styleTypeName && item.styleTypeName.indexOf("跨境权益") != -1){
        colorArr.push("#ef5002")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("国内权益") != -1){
        colorArr.push("#e22424")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("跨境债券") != -1){
        colorArr.push("#f25a0f")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("另类") != -1){
        colorArr.push("#f0d331")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("货币") != -1){
        colorArr.push("#23c7e2")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("国内债券") != -1){
        colorArr.push("#034ab2")
      }
    })

    return(
      <div>
        {
          data.map(function(itme,i){
            if(i%2 === 0 ){
              return(
                <div className="pzList_div" key={ i } style={{ backgroundColor:'#FFF' }}>
                  <div className="pzList_name" >
                    { itme.fundName }
                  </div>
                  <div className="pz_rateDiv" >
                    <div style={{ width:"1.1rem"}}>
                      {
                        Util.newToFixed(itme.regularRate*100,2) + "%"
                      }
                    </div>
                    <div style={{ WebkitFlex:Util.newToFixed(itme.regularRate)*10, flex:Util.newToFixed(itme.regularRate)*10, background:colorArr[i],height:'0.28rem',borderRadius:'4px'}}></div>
                    <div style={{ WebkitFlex:10-Util.newToFixed(itme.regularRate)*10, flex:10-Util.newToFixed(itme.regularRate)*10, height:'0.4rem'}}></div>
                  </div>
                </div>
              )
            }else{
              return(
                <div className="pzList_div" style={{ backgroundColor:'#FFF' }} key = { i }>
                  <div className="pzList_name" >
                    { itme.fundName }
                  </div>
                  <div className="pz_rateDiv">
                    <div style={{ width:"1.1rem"}}>
                      { Util.newToFixed(itme.regularRate*100,2) + "%" }
                    </div>
                    <div style={{ WebkitFlex:Util.newToFixed(itme.regularRate)*10,  flex:Util.newToFixed(itme.regularRate)*10, background:colorArr[i],height:'0.28rem',borderRadius:'4px'}}></div>
                    <div style={{ WebkitFlex:10-Util.newToFixed(itme.regularRate)*10, flex:10-Util.newToFixed(itme.regularRate)*10, height:'0.4rem'}}></div>
                  </div>
                </div>
              )
            }
          })
        }
      </div>
    )
  }
}

export class FundListHave extends Component{
  constructor(props) {
    super(props);
    this.state = {};
  }
  render(){
    let data = this.props.data;
    let colorArr = [];
    data.map((item,key)=>{
      if(item.styleTypeName && item.styleTypeName.indexOf("跨境权益") != -1){
        colorArr.push("#ef5002")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("国内权益") != -1){
        colorArr.push("#e22424")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("跨境债券") != -1){
        colorArr.push("#f25a0f")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("另类") != -1){
        colorArr.push("#f0d331")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("货币") != -1){
        colorArr.push("#23c7e2")
      }else if(item.styleTypeName && item.styleTypeName.indexOf("国内债券") != -1){
        colorArr.push("#034ab2")
      }
    })

    return(
      <div>
        {
          data.map(function(itme,i){
            if(i%2 === 0 ){
              return(
                <div className="pzList_div" key={ i }>
                  <div className="pzList_name" >
                    { itme.fundName }
                  </div>
                  <div className="pz_rateDiv" >
                    <div style={{ width:"0.8rem"}}>
                      {
                        Util.newToFixed(itme.rateInGroup*10,1)*10 + "%"
                      }
                    </div>
                    <div style={{ WebkitFlex:Util.newToFixed(itme.rateInGroup)*10, flex:Util.newToFixed(itme.rateInGroup)*10, background:colorArr[i],height:'0.28rem',borderRadius:'4px'}}></div>
                    <div style={{ WebkitFlex:10-Util.newToFixed(itme.rateInGroup)*10, flex:10-Util.newToFixed(itme.rateInGroup)*10, height:'0.4rem'}}></div>
                  </div>
                </div>
              )
            }else{
              return(
                <div className="pzList_div" style={{ backgroundColor:'#FFF' }} key = { i }>
                  <div className="pzList_name" >
                    { itme.fundName }
                  </div>
                  <div className="pz_rateDiv">
                    <div style={{ width:"0.8rem"}}>
                      { Util.newToFixed(itme.rateInGroup*10,1)*10 + "%" }
                    </div>
                    <div style={{ WebkitFlex:Util.newToFixed(itme.rateInGroup)*10,  flex:Util.newToFixed(itme.rateInGroup)*10, background:colorArr[i],height:'0.28rem',borderRadius:'4px'}}></div>
                    <div style={{ WebkitFlex:10-Util.newToFixed(itme.rateInGroup)*10, flex:10-Util.newToFixed(itme.rateInGroup)*10, height:'0.4rem'}}></div>
                  </div>
                </div>
              )
            }
          })
        }
      </div>
    )
  }
}

export class TabComponent extends Component{
  constructor(props) {
    super(props);
    this.state = {
      tabName:'配置概况',
      setModalShow:false
    };
  }
  tabClick(data){
    if(data === "配置详情"){
         window._czc.push(["_trackEvent", "华夏财富H5", "智投详情", "点击配置详情"]);
    }
    this.setState({
      tabName:data
    })
  }
  agreeFunSec=()=>{
		this.setState({
      setModalShow: false,
		});
  }
  setModal(){
    console.log(11111)
		this.setState({
      setModalShow: true,
		});
  }
 
  render(){
    let { tabName } = this.state;
    let { pieImg } = this.props;

    //let data = this.props.data ? this.props.data.productQueryResponse.itemFunds : [];
    let dataTwo = this.props.data ? this.props.data.productQueryResponse.itemFunds : [];
    let data = this.props.data ? this.props.data.pieTableQuery.itemFunds : [];
    let seasonPublishDate = this.props.data ? this.props.data.productQueryResponse.seasonPublishDate : "--";
    data.sort(compare('regularRate'))
    dataTwo.sort(compare('regularRate'))

    let arrObj = []
    let arrName = [];

    let opt = JSON.parse(JSON.stringify(data));
    for(var i=0; i<opt.length; i++){
      for(var j=i+1; j<opt.length; j++){
        if(opt[i].styleTypeName==opt[j].styleTypeName){
          opt[i].regularRate = Number(opt[i].regularRate) + Number(opt[j].regularRate)
          opt.splice(j,1)
          j--;
        }
      }
    }
    opt.sort(compare('regularRate'))
    for(let i=0; i<opt.length; i++){
      if(opt[i].styleTypeName == "货币基金") {
        continue;
      }
      arrObj.push({
        value: Util.newToFixed( opt[i].regularRate * 100,0 ),
        name: opt[i].styleTypeName ? opt[i].styleTypeName.replace(/基金/g, "") + Util.newToFixed(opt[i].regularRate * 100,0) + "%" : "--" + Util.newToFixed(opt[i].regularRate * 100,0) + "%"
      })
      if(opt[i].styleTypeName) {
        arrName.push(
          opt[i].styleTypeName.replace(/基金/g, "") + Util.newToFixed(opt[i].regularRate * 100,0) + "%"
        )
      }else {
        arrName.push(
          Util.newToFixed(opt[i].regularRate * 100,0) + "%"
        )
      }
    }
    if(opt.length > 0) {
      let allVal = 100;
      for(let s = 0; s < arrObj.length; s++) {
        allVal = allVal - arrObj[s].value;
      }
      arrObj.push({
        value: allVal,
        name: "货币" + allVal + "%"
      });
      arrName.push("货币" + allVal + "%")
    }
    console.log(414,arrObj)
    return(
      <div>
        <div style={{backgroundColor:"#FFF",paddingLeft:15,paddingRight:15}}>
          <div style={{display:"-webkit-flex", marginTop: 10, WebkitFlexDirection: "row", WebkitJustifyContent: "flex-start", WebkitAlignItems: "center",height: 45,lineHeight: "45px", borderColor:'#ebedf0',borderWidth:0,borderBottomWidth:1,width:"100%", borderStyle: "solid"}}>
            <span style={{color: "#505558", fontSize: "0.32rem"}}>配置概况</span>
            <img 
              onClick={this.props.handleAlert}
              style={{
              height:"0.32rem",
              width: "0.32rem",
              color: "#FA063A",
              marginLeft: 6
            }} src={require("../../img/smallWh.png")} />
          </div>
          {/*<div className={ tabName === "配置详情" ? "tabClick" : "tabDefault" } onClick={ ()=> { this.tabClick("配置详情") }}>
            <span>配置详情</span>
          </div>*/}
        </div>
        <div>
          {
            tabName  === "配置概况" ? 
            ( data.length > 0 ? <SuperPie data={ arrObj } dataName = { arrName } pieImg = { pieImg }/> : <div id="SuperPie" style={{ width:"100%", height:360, }}></div> ) : <FundList data={ dataTwo }/>
          }
          
           
            {/*<div style={{height: "0.8rem", fontSize: "0.22rem", lineHeight: "0.8rem", backgroundColor: "#fff", width:'100%', textAlign:"right",paddingRight: 15,}} onClick={this.props.handleAlert}>更新时间: {seasonPublishDate.substring(0,10)}
             <img style={{
                    height:"0.32rem",
                    width: "0.32rem",
                    color: "#FA063A",
                    lineHeight: "0.42rem",
                    marginBottom:"-0.09rem",
                    marginLeft: 3
                  }} src={require("../../img/smallWh.png")} />
            </div>*/}

           
        </div>
        <ModalList flag={this.state.setModalShow} title = '查理解密' content ={'该图展示基金投资组合策略目标配置情况。' } btnRight = '我知道了' btnRightFun = {this.agreeFunSec} />

      </div>
    )
  }
}

export class PieCharNew extends Component{
  constructor(props) {
    super(props);
    this.state = {
    
    };
  }
  render(){
    const { pieImg , flag } = this.props;
    let corArr = [];
    let data = this.props.data ? this.props.data.pieTableQueryResponse.itemFunds : [];
    // let optTwo = [];
    // optTwo = data.slice(0);
    // optTwo.sort(compare('regularRate'))
    let opt = [];
    opt = JSON.parse(JSON.stringify(data));
    for(var i=0; i<opt.length; i++){
      for(var j=i+1; j<opt.length; j++){
        if(opt[i].styleTypeName==opt[j].styleTypeName){
          opt[i].regularRate = Number(opt[i].regularRate) + Number(opt[j].regularRate)
          opt.splice(j,1)
          j--;
        }
      }
    }

    // optTwo.map((item,key)=>{
    //   if(item.styleTypeName.indexOf("跨境权益") != -1){
    //     corArr.push("#4729c5")
    //   }else if(item.styleTypeName.indexOf("国内权益") != -1){
    //     corArr.push("#e22424")
    //   }else if(item.styleTypeName.indexOf("跨境债券") != -1){
    //     corArr.push("#f25a0f")
    //   }else if(item.styleTypeName.indexOf("另类") != -1){
    //     corArr.push("#f0d331")
    //   }else if(item.styleTypeName.indexOf("货币") != -1){
    //     corArr.push("#23c7e2")
    //   }else if(item.styleTypeName.indexOf("国内债券") != -1){
    //     corArr.push("#034ab2")
    //   }
    // })

    let arrObj = []
    let arrName = [];
    opt.sort(compare('regularRate'))
    for(let i=0; i<opt.length; i++){
      if(opt[i].styleTypeName == "货币基金") {
        continue;
      }
      arrObj.push({
        value: Util.newToFixed( opt[i].regularRate * 100,0 ),
        name: opt[i].styleTypeName ? opt[i].styleTypeName.replace(/基金/g, "") + Util.newToFixed(opt[i].regularRate * 100,0) + "%" : "--" + Util.newToFixed(opt[i].regularRate * 100,0) + "%"
      })
      if(opt[i].styleTypeName) {
        arrName.push(
          opt[i].styleTypeName.replace(/基金/g, "") + Util.newToFixed(opt[i].regularRate * 100,0) + "%"
        )
      }else {
        arrName.push(
          Util.newToFixed(opt[i].regularRate * 100,0) + "%"
        )
      }
    }
    if(opt.length > 0) {
      let allVal = 100;
      for(let s = 0; s < arrObj.length; s++) {
        allVal = allVal - arrObj[s].value;
      }
      arrObj.push({
        value: allVal,
        name: "货币" + allVal + "%"
      });
      arrName.push("货币" + allVal + "%")
    }
    // console.log(optTwo,"optTwooptTwooptTwooptTwo")

    if(flag){
      return(
          <div>
          {
             data.length > 0 ? <SuperPie data={ arrObj } dataName = { arrName } pieImg = { pieImg }/> : <div id="SuperPie" style={{ width:"100%", height:360, }}></div>
          }
        </div>
          
      )
    }else{
      return(
          <div style={{paddingLeft:10, paddingRight:10,background:"#FFF",paddingBottom:10 }}>

          </div>
      )
    }

  }
}

export class PieCharHaveNew extends Component{
  constructor(props) {
    super(props);
    this.state = {
      setModalShow: false,
    };
  }
  agreeFunSec=()=>{
		this.setState({
      setModalShow: false,
		});
  }
  setModal(){
    console.log(11111)
		this.setState({
      setModalShow: true,
		});
  }
  judgmentMonthlyReport(code){
    console.log(Util.superFundCodeArrByZX.some((item)=>{item===code}),code)
    return Util.superFundCodeArrByZX.some((item)=>item===code)
  }
  render(){
    const { pieImg , flag } = this.props;
    //let data = this.props.data ? this.props.data.productQueryResponse.itemFunds : [];
    let corArr = [];
    let dataTwo = this.props.data ? (this.props.data.shareQueryResponse.fundItems ? this.props.data.shareQueryResponse.fundItems : []) : [];
    let data = this.props.data ? (this.props.data.pieTableQueryResponse.itemFunds ? this.props.data.pieTableQueryResponse.itemFunds : []) : [];
    let seasonPublishDate = this.props.data ? (this.props.data.productQueryResponse.seasonPublishDate ? this.props.data.productQueryResponse.seasonPublishDate : "--") : "--";
    data.sort(compare('regularRate'))
    dataTwo.sort(compare('rateInGroup')) 
    
    // let optTwo = [];
    // optTwo = data.slice(0);
    // optTwo.sort(compare('rateInGroup'))
    // for(let k=0; k<optTwo.length; k++){
    //   if(optTwo[k].rateInGroup <= 0.01){
    //     optTwo.splice(k,1)
    //   }
    // }
    let opt = [];
    opt = JSON.parse(JSON.stringify(data));
    for(let k=0; k<opt.length; k++){
      if(opt[k].regularRate <= 0.01){
        opt.splice(k,1)
      }
    }
    for(let i=0; i<opt.length; i++){
      for(let j=i+1; j<opt.length; j++){
        if(opt[i].styleTypeName==opt[j].styleTypeName){
          opt[i].regularRate = Number(opt[i].regularRate) + Number(opt[j].regularRate)
          opt.splice(j,1)
          j--;
        }
      }
    }

    // optTwo.map((item,key)=>{
    //   if(item.styleTypeName.indexOf("跨境权益") != -1){
    //     corArr.push("#4729c5")
    //   }else if(item.styleTypeName.indexOf("国内权益") != -1){
    //     corArr.push("#e22424")
    //   }else if(item.styleTypeName.indexOf("跨境债券") != -1){
    //     corArr.push("#f25a0f")
    //   }else if(item.styleTypeName.indexOf("另类") != -1){
    //     corArr.push("#f0d331")
    //   }else if(item.styleTypeName.indexOf("货币") != -1){
    //     corArr.push("#23c7e2")
    //   }else if(item.styleTypeName.indexOf("国内债券") != -1){
    //     corArr.push("#034ab2")
    //   }
    // })

    console.log(data)
    let arrObj = []
    let arrName = [];
    opt.sort(compare('regularRate'))
    for(let i=0; i<opt.length; i++){
      if(opt[i].styleTypeName == "货币基金") {
        continue;
      }
      arrObj.push({
        value: Util.newToFixed( opt[i].regularRate * 100,0 ),
        name: opt[i].styleTypeName ? opt[i].styleTypeName.replace(/基金/g, "") + Util.newToFixed(opt[i].regularRate * 100,0) + "%" : "--" + Util.newToFixed(opt[i].regularRate * 100,0) + "%"
      })
      if(opt[i].styleTypeName) {
        arrName.push(
          opt[i].styleTypeName.replace(/基金/g, "") + Util.newToFixed(opt[i].regularRate * 100,0) + "%"
        )
      }else {
        arrName.push(
          Util.newToFixed(opt[i].regularRate * 100,0) + "%"
        )
      }
    }
    if(opt.length > 0) {
      let allVal = 100;
      for(let s = 0; s < arrObj.length; s++) {
        allVal = allVal - arrObj[s].value;
      }
      arrObj.push({
        value: allVal,
        name: "货币" + allVal + "%"
      });
      arrName.push("货币" + allVal + "%")
    }

    if(flag){
      return(
          <div>
          {
             data.length > 0 ? <SuperPie data={ arrObj } dataName = { arrName } pieImg = { pieImg }/> : <div id="SuperPie" style={{ width:"100%", height:360, }}></div>
          }
        </div>
          
      )
    }else{
      if(true) {
        return null
      }else {
        return(
          <div style={{paddingLeft:10, paddingRight:10,background:"#FFF",paddingBottom:10 }}>
            <div style={{ borderRadius:10, background:"#F6F9FC", minHeight:50, height:'auto', overflow:'hidden',fontSize:"0.24rem" }}>
            { 
              dataTwo.map(function(itme,i){
                if(i < i - 1 ){
                  return(
                    <div className="pzList_div" key={ i } style={{ borderBottom:'1px solid #ebedf0'}}>
                      <div className="pzList_name" style={{fontSize:'0.24rem'}}>
                        { itme.fundName }
                      </div>
                      {/*<div className="pz_rateDiv" >
                        <div style={{ WebkitFlex:2, flex:2}}>
                          {
                            Util.newToFixed(itme.rateInGroup*10,1)*10 + "%"
                          }
                        </div>

                        <div style={{ WebkitFlex:3, flex:3, height:'0.4rem'}}>{ Util.newToFixed(itme.balance) + "元" }</div>
                      </div>*/}
                      <div className="pz_rateDiv" >
                        <div style={{ WebkitFlex:1, flex:1, WebkitAlignItems: "center", WebkitJustifyContent: "center", display: "-webkit-flex"}}>
                          {
                            Util.newToFixed(itme.rateInGroup*100,2) + "%"
                          }
                        </div>

                      </div>
                    </div>
                  )
                }else{
                  return(
                    <div className="pzList_div" key = { i }>
                      <div className="pzList_name" style={{fontSize:'0.24rem'}} >
                        { itme.fundName }
                      </div>
                      {/*<div className="pz_rateDiv">
                        <div style={{ WebkitFlex:2, flex:2 }}>
                          { Util.newToFixed(itme.rateInGroup*10,1)*10 + "%" }
                        </div>
                        <div style={{ WebkitFlex:3, flex:3,  height:'0.4rem'}}>{Util.newToFixed(itme.balance) + "元"}</div>
                      </div>*/}
                      <div className="pz_rateDiv">
                        <div style={{ WebkitFlex:1, flex:1, WebkitAlignItems: "center", WebkitJustifyContent: "center", display: "-webkit-flex"}}>
                          { Util.newToFixed(itme.rateInGroup*100,2) + "%" }
                        </div>
                      </div>
                    </div>
                  )
                }
              })

            }
            <div className="pzList_div">
            {console.log(this.props.superFundCode)}
            {this.judgmentMonthlyReport(this.props.superFundCode)?
              <div style={{textAlign: "right", width:"100%", lineHeight:"0.8rem", paddingRight: 15}} onClick={this.props.handleAlert}>更新时间: {seasonPublishDate.substring(0,10)}
              <img style={{
                    height:"0.32rem",
                    width: "0.32rem",
                    color: "#FA063A",
                    lineHeight: "0.42rem",
                    marginBottom:"-0.09rem",
                    marginLeft: 3
                  }} src={require("../../img/smallWh.png")} />
                </div>
                 :
                 <div style={{height: "0.8rem", fontSize: "0.22rem", lineHeight: "0.8rem", backgroundColor: "#fff", width:'100%', textAlign:"right",paddingRight: 15,}}>更新时间: {seasonPublishDate.substring(0,10)}
                 
                 </div>
                }
               
            </div>
            </div>
           <ModalList flag={this.state.setModalShow} title = '查理解密' content ={'该图展示基金投资组合策略目标配置情况。' } btnRight = '我知道了' btnRightFun = {this.agreeFunSec} />

          </div>
        )
      }
    }

  }
}

export class TabComponentHave extends Component{
  constructor(props) {
    super(props);
    this.state = {
      tabName:'配置概况'
    };
  }
  tabClick(data){
    this.setState({
      tabName:data
    })
  }

  render(){
    let { tabName } = this.state;
    let { pieImg } = this.props;

    //let data = this.props.data ? this.props.data.productQueryResponse.itemFunds : [];
    let corArr = [];
    let data = this.props.data ? (this.props.data.shareQueryResponse.fundItems ? this.props.data.shareQueryResponse.fundItems : []) : [];
    data.sort(compare('rateInGroup')) 
    
    // let optTwo = [];
    // optTwo = data.slice(0);
    // optTwo.sort(compare('rateInGroup'))
    // for(let k=0; k<optTwo.length; k++){
    //   if(optTwo[k].rateInGroup <= 0.01){
    //     optTwo.splice(k,1)
    //   }
    // }
    let opt = [];
    opt = JSON.parse(JSON.stringify(data));
    for(let k=0; k<opt.length; k++){
      if(opt[k].rateInGroup <= 0.01){
        opt.splice(k,1)
      }
    }
    for(let i=0; i<opt.length; i++){
      for(let j=i+1; j<opt.length; j++){
        if(opt[i].styleTypeName==opt[j].styleTypeName){
          opt[i].rateInGroup = Number(opt[i].rateInGroup) + Number(opt[j].rateInGroup)
          opt.splice(j,1)
          j--;
        }
      }
    }

    // optTwo.map((item,key)=>{
    //   if(item.styleTypeName.indexOf("跨境权益") != -1){
    //     corArr.push("#4729c5")
    //   }else if(item.styleTypeName.indexOf("国内权益") != -1){
    //     corArr.push("#e22424")
    //   }else if(item.styleTypeName.indexOf("跨境债券") != -1){
    //     corArr.push("#f25a0f")
    //   }else if(item.styleTypeName.indexOf("另类") != -1){
    //     corArr.push("#f0d331")
    //   }else if(item.styleTypeName.indexOf("货币") != -1){
    //     corArr.push("#23c7e2")
    //   }else if(item.styleTypeName.indexOf("国内债券") != -1){
    //     corArr.push("#034ab2")
    //   }
    // })

    console.log(data)
    let arrObj = []
    let arrName = [];
    opt.sort(compare('rateInGroup'))
    for(let i=0; i<opt.length; i++){
      arrObj.push({
        value: Util.newToFixed( opt[i].rateInGroup * 100 ),
        name: opt[i].styleTypeName ? opt[i].styleTypeName.replace(/基金/g, "") + Util.newToFixed(opt[i].rateInGroup * 100) + "%" : "--" + Util.newToFixed(opt[i].rateInGroup * 100) + "%"
      })
      if(opt[i].styleTypeName) {
        arrName.push(
          opt[i].styleTypeName.replace(/基金/g, "") + Util.newToFixed(opt[i].rateInGroup * 100,0) + "%"
        )
      }else {
        arrName.push(
          Util.newToFixed(opt[i].rateInGroup * 100,0) + "%"
        )
      }
    }
    console.log(414,arrObj)
    return(
      <div>
        <div style={{ height:'0.9rem',borderBottom:'1px solid #ebedf0', background:"#FFF", display: "-webkit-flex", padding:'0 0.1rem 0 0.1rem'}}>
          <div className={ tabName === "配置概况" ? "tabClick" : "tabDefault" } onClick={ () => this.tabClick("配置概况") }>
            <span>配置概况</span>
          </div>
          <div className={ tabName === "配置详情" ? "tabClick" : "tabDefault" } onClick={ ()=> { this.tabClick("配置详情") }}>
            <span>配置详情</span>
          </div>
        </div>
        <div>
          {
            tabName  === "配置概况" ? 
            ( data.length > 0 ? <SuperPie data={ arrObj } dataName = { arrName } pieImg = { pieImg }/> : <div id="SuperPie" style={{ width:"100%", height:360, }}></div> ) : <FundListHave data={ data }/>
          }
        </div>
      </div>
    )
  }
}


export class LineComponent extends Component{
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
     // var myChart = echarts.init(document.getElementById('SuperLine'));
     //  // 绘制图表
     //  let dataArr = [];
     //  this.props.data2 ? this.props.data2.map(function(item){
     //    dataArr.push(Util.newToFixed(item*100))
     //  }): null
     //  myChart.setOption(returnLineOption(this.props.data1,dataArr));
  }
  shouldComponentUpdate(nextProps = {}, nextState = {}) {
      const thisProps = this.props || {}, thisState = this.state || {};
      for (const key in nextProps) {
        if (thisProps[key] !== nextProps[key] ) {
          return true;
        }
      }

      for (const key in nextState) {
        if (thisState[key] !== nextState[key] ) {
          return true;
        }
      }
      
      return false;
  }
  componentWillUpdate(nextProps, nextState) {

  }
  componentDidUpdate(){
    if (window.isLess47) {
      var myChart = echarts.init(document.getElementById('SuperLine'));
    }else{
      var myChart = echarts.init(document.getElementById('SuperLine'), null, {renderer: 'svg'});
    }
    let dataArr = [];
    myChart.clear();
    myChart.setOption(returnLineOption(this.props.data1,this.props.data2,this.props.data3));
  }
  componentWillUnmount(){
    var myChart = echarts.init(document.getElementById('SuperLine'));
  }
  render(){
    return(
      <div id="SuperLine" style={{ width:"100%", height:360, overflow:"hidden" }}></div>
    );
  }
}

export class FxBarComponent extends Component{
  constructor(props) {
    super(props);
    this.state = {
      dataX:["资产配置收益","基金选择收益","业绩基准收益"],
      dataY:[0.09,0.38,0.18],
      sumX:0.00,
      date:"2017-01-01",
      flag:true
    };
  }
  componentDidMount() {
     // var myChart = echarts.init(document.getElementById('FxBar'));
     //  // 绘制图表
     //  let dataArr = [];
     //  this.props.data2 ? this.props.data2.map(function(item){
     //    dataArr.push(Util.newToFixed(item*100))
     //  }): null
     //  myChart.setOption(returnLineOption(this.props.data1,dataArr));
     let { dispatch, superFundCode } = this.props;
     let inData = {
      fundCode:superFundCode,
     }
     dispatch(getFindAssetConfig(inData,this.handleCallBack.bind(this),this))
  }
  handleCallBack(data){
    console.log(data,"组合分析 绩效分解组合分析 绩效分解组合分析 绩效分解")
    let dataX = [];
    let dataY = [];
    let sumX = 0;
    let flag = true;
    for(let i=data.length - 1; i>=0; i--){
      if(data[i].configValue === null){
        flag = false;
        break;
      }
      dataX.push(data[i].configName)
      dataY.push(data[i].configValue.replace(/%/, ""))
      sumX += Number(data[i].configValue.replace(/%/, ""));
    }
    this.setState({
      dataX,dataY,sumX,flag,
      date:data[0].analyDate
    })
    if (window.isLess47) {
      var myChart = echarts.init(document.getElementById('FxBar'));
    }else{
      var myChart = echarts.init(document.getElementById('FxBar'), null, {renderer: 'svg'});
    }
     
      // 绘制图表
      let dataArr = [];
      this.props.data2 ? this.props.data2.map(function(item){
        dataArr.push(Util.newToFixed(item*100))
      }): null
      myChart.clear();
      let optionBar = {
          title: {
              text: '',
              subtext: '',
              sublink: ''
          },
          animation: window.isLess47,
          grid: {
              left: '3%',
              right: '4%',
              bottom: '10%',
              containLabel: true
          },
          xAxis: {
              type : 'category',
              axisLine: {
                  show: false
              },
              axisTick:{
                 lineStyle:{
                    width:0,
                    color:"#9BC4D8"
                },
          
              },
              axisLabel: {
                  textStyle: {/*x轴文字颜色*/
                      color: '#CCC',
                      fontSize:'12'
                  },
              }, 
              // axisLabel: {
              //     show:true,
              //     color: function(data, index) {
              //         console.log(data, index)
              //         var corArr = ["red", "blue", "yellow", "blue", "green", "orange"];
              //         return corArr[index]
              //     }
              // },
              data : dataX
          },
          yAxis: {
              type : 'value',
              axisTick: {
                  show: false
              },
              splitLine: {
                  lineStyle: {
                      color: "rgb(240,241,242)"
                  }
              },
              // axisLabel: {
              //     color: function(data, index) {
              //         console.log(data, index)
              //         var corArr = ["red", "blue", "yellow", "blue", "green", "orange"];
              //         return corArr[index]
              //     }
              // },
              axisLine: {
                  show: false
              },
              axisLabel: {
                  formatter: '{value} %',
                  textStyle: {/*y轴文字颜色*/
                      color: '#CCC',
                  },
              }
          },
          series: [
            {
                name: '组合分析',
                type: 'bar',
                clickable:false,
                hoverAnimation:false,
                stack: '总量',
                label: {
                    normal: {
                        show: false,
                        position: 'top',
                        color: "auto"
                    }
                },
                barWidth : 30,//柱图宽度
                data:dataY
            }
          ],
          color : ["#23c7e2","#d4d9b0","#265573"]
        };
      myChart.setOption(optionBar);
  }
  componentWillUpdate(nextProps, nextState) {

  }
  componentDidUpdate(){
    
  }
  render(){
    let { date, sumX, flag } = this.state;
    return(
      <div style={{ background: "#FFF" }}>
        {
          flag ? 
          <div>
                <div className="zhFx_div">

                <span style={{ fontSize:"14px" }}>组合分析</span> <span style={{ fontSize:"11px",}}>(绩效归因分解)</span>

              <div className="wenHao" onClick={()=>{ this.props.handleAlert() }}>
     
              </div>
            </div>
            <div style={{ textAlign:"center", position:"relative",bottom:-10}}><span style={{ fontSize:"13px" }}>组合收益：</span><span style={{ color:sumX >= 0 ? "#fb615b" : "#7fdd81", fontSize:"14px" }}>{ Util.newToFixed(sumX) + "%" }</span></div>
            <div id="FxBar" style={{ width:"100%", height:360, paddingLeft:'8px', background: "#FFF" }}></div>
            <div style={{ fontSize:12, color:"#CCC", textAlign:"right", paddingRight:"13px", position:"relative", top:-10 }}>基于该组合{ date.substr(0,4) }年{ date.substr(5,2) }月数据分析 </div>    
          </div> : null
        }
        
      </div>
    );
  }
}

/*调仓记录*/
export class AdjustRecord extends Component{
  constructor(props) {
    super(props);
    this.state = {
      data:null
    };
    this.dataSouce=[]
  }
  componentDidMount() {
    let { dispatch } = this.props;
    let inData = {
      superFundCode:this.props.superFundCode
    }
    dispatch(getHistoryAdjust(inData,this.handleCallBack.bind(this),this))
  }
  handleCallBack(data){
    this.dataSouce=data;
    this.setState({
      data: data[data.length - 1]
    })
  }
  pushHistoryRate(){
    hashHistory.push({
      pathname:'/TransitHistory',
      state:{data:this.dataSouce}
    })
  }
  render(){
    let { data } = this.state;
    return(
      <div>
        <div style={{padding:"0 15px 0 15px",background:"#FFF",marginTop:10}}>
          <div className="comonTitle" style={{borderBottom:'1px solid #ebedf0',background:"#FFF" }}>
            <div style={{marginLeft:0}}><span style={{color:'#505558',fontSize:'0.32rem'}}>调仓记录</span></div>
            <div style={{marginRight:0}}> <span style={{color:'#828C96', fontSize:'0.26rem'}}>{data?Util.returnDate(data.adjustDate):''}</span></div>
          </div>
        </div>
        <AdjustRecordContent data={data} />
        <div onClick={this.pushHistoryRate.bind(this)} className="more_AdjustRecord" style={{height:"48px", background:"#FFF",borderTop:'1px solid #ebedf0',color:'#828892',fontSize:'0.26rem' }}>
              <span>查看历史调仓</span><img src={require('../../imgs/eq_arrowRight@3x.png')} style={{width:44,height:44,marginLeft:-12}}/> 
        </div>
      </div>
    )    
  }
}

export class AdjustRecordContent extends Component{
  render(){
    let { data } = this.props;
    console.log(data,"调仓调仓")
    return(
      <div style={{background:"#FFF" }}>
          <div className="adjust_title_wrap">
            <div style={{  height:58, borderBottom:"1px #ebeef0 solid", paddingTop:16, paddingLeft:13, paddingRight:13, color:"#3a3e47", fontSize:12 }}>
              根据最近的市场情况,  查理对组合进行了资产配置比例调整:
            </div>
          </div>
          <div className="tabAdjust_list">
            <div>
              <span  style={{ fontSize:12, color:"#a1a7b2"  }}>基金名称</span>
            </div>
            <div >
              <span style={{ fontSize:12, color:"#a1a7b2"  }}>调整前比例</span>
            </div>
            <div>
              <span style={{ fontSize:12, color:"#a1a7b2" }}>调整后比例</span>
            </div>
          </div>

          <div>
            {
              data ? data.itemAdjustList.map((item,index)=>{
                if(index%2 === 0){
                  return(
                    <div className="Adjust_list" key={index}>
                      <span>{ item.fundName }</span>
                      <span>{ Util.newToFixedOne(item.beforeRate*100,1) + "%" }</span>
                      <span>{ Util.newToFixedOne(item.afterRate*100,1) + "%" }</span>
                    </div>
                  )
                }else{
                  return(
                    <div className="Adjust_list2" key={index}>
                      <span>{ item.fundName }</span>
                      <span>{ Util.newToFixedOne(item.beforeRate*100,1) + "%" }</span>
                      <span>{ Util.newToFixedOne(item.afterRate*100,1) + "%" }</span>
                    </div>
                  )
                }
              }) : null
            }

          </div>
      </div>
    )
  }
}




export class ProblemList extends Component{
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    
  }
  goDetail = (content,key) => {
    if(key == 0){
      window._czc.push(["_trackEvent", "华夏财富H5", "智投详情", "智投百科列表问题一进入按钮"]);
    }else if(key == 1){
      window._czc.push(["_trackEvent", "华夏财富H5", "智投详情", "智投百科列表问题二进入按钮"]);
    }else if(key == 2){
      window._czc.push(["_trackEvent", "华夏财富H5", "智投详情", "智投百科列表问题三进入按钮"]);
    }


    hashHistory.push({
      pathname: "/encyclopediaDetail",
      state: {
        content: content
      }
     });
  }
  render(){
    let data = this.props.data? this.props.data.problemList.content.rows : [];
    return(
      <div className="problemList">
        <div className="eq_ztDetail_title">
            <div>
              智投百科
            </div>
        </div>

        {
          data.map((item,i)=>{
            if(i < 3){
              return(
                <div className="problemItem" key={ i } onClick={ () => this.goDetail(item.title,i) }>
                  <div style={{ WebkitFlex:1 }}>
                    { item.content }
                  </div>
                  <div></div>
                </div>
              )
            }
          })
        }
      </div>
    )
  }
}




/*饼图Option*/
function SuperPieOption(data,dataName){
  let colorArr = [];
  if(dataName){
  dataName.map((item,key)=>{
      if(item && item.indexOf("跨境权益") != -1){
        colorArr.push("#ef5002")
      }else if(item && item.indexOf("国内权益") != -1){
        colorArr.push("#e22424")
      }else if(item && item.indexOf("跨境债券") != -1){
        colorArr.push("#f25a0f")
      }else if(item && item.indexOf("另类") != -1){
        colorArr.push("#f0d331")
      }else if(item && item.indexOf("货币") != -1){
        colorArr.push("#23c7e2")
      }else if(item && item.indexOf("国内债券") != -1){
        colorArr.push("#034ab2")
      }
    })
  }
  let hg = 60;
  if( dataName.length <= 2){
    hg = 20;
  }else if(dataName.length <= 4){
    hg=60;
  }else if(dataName.length <= 6){
    hg=80;
  }else if(dataName.length <= 8){
    hg=100;
  }

  let SuperPieOption = {
        animation: window.isLess47,

    calculable : true,
    legend: {
        // y : 'bottom',
        // x: 'center',
        // data:dataName,
        // textStyle:{color:"auto"}
        y : 'bottom',
        x: 'center',
        orient:'vertical',
        data:dataName,
        height:80,
        itemWidth:14,
        selectedMode:false,
        textStyle:{color:"auto"}
    },
    series : [
        {
            type:'pie',
            hoverAnimation:false,
            radius : [44, 100],
            center : ['50%', '40%'],
            // roseType : 'radius',
            roseType:false,
            data:data,
            // [
            //     {value:15, name:'货币基金15.0%'},
            //     {value:20, name:'均衡股票20.0%'},
            //     {value:25, name:'进取股票25.0%'},
            //     {value:40, name:'稳健型债券40.0%'},
            // ],
          label:{
            normal:{
              show:false
            }
          },
          labelLine:{
            normal:{
              show:false
            }
          },

        }
    ],
    color:colorArr
  }

  SuperPieOption = {
        animation: window.isLess47,

      calculable : true,
      legend: {
          // y : 'bottom',
          // x: 'center',
          // data:dataName,
          // textStyle:{color:"auto"}

          // y : 'center',
          // x: 'left',
          // left:width/2 + 40,
          // orient:'vertical',


          y : 'center',
          x: 'left',
          // left:width/2 + 40,
          left:20,
          orient:'vertical',
          data:dataName,
          //height:hg,
          itemWidth:14,
          selectedMode:false,
          textStyle:{color:"auto"}
      },
      series : [
          {   
              minAngle:20,
              type:'pie',
              hoverAnimation:false,
              radius : [44, 75],
              // center : ['30%', '50%'],
              center : ['70%', '50%'],
              // roseType : 'radius',
              roseType:false,
              data:data,
              // [
              //     {value:15, name:'货币基金15.0%'},
              //     {value:20, name:'均衡股票20.0%'},
              //     {value:25, name:'进取股票25.0%'},
              //     {value:40, name:'稳健型债券40.0%'},
              // ],
            label:{
              normal:{
                show:false
              }
            },
            labelLine:{
              normal:{
                show:false
              }
            },

          }

      ],
      color:colorArr
      //color: ['#db6a3d','#427bc7','#2ca1bd','#f5ad3c']
      //color: ['#4729c5','#e22424','#f25a0f','#f0d331','23c7e2','034ab2']
    };

  return SuperPieOption;
}

/*折线图Option*/
function returnLineOption(data1,data2,data3){
  console.log(width,"widthwidthwidthwidthwidthwidth")
  let pValue = 0;
  if(width<350){
    pValue = 0;
  }else if(width < 400){
    pValue = 13;
  }else{
    pValue = 23;
  }

  let option;
  if(data1){
      option = {
        // tooltip : {
        //     trigger: 'axis'
        // },
        animation: window.isLess47,
        grid:{
          left:47,
        },
        // legend: {
        //     data:['2030TDF','沪深300指数','2030TDF比较基准','目标日期-2030'],
        //     y : 'bottom',
        //     x: 'center',
        //     textStyle:{color:"a1a7b2"}
        // },
        tooltip : {
          show:true,
          trigger: 'axis',
          alwaysShowContent:true,
          position:[width/2,0],
          padding:[16,300,0,pValue],
          axisPointer:{
                type: 'line',
                lineStyle: {
                    color: '#48b',
                    width: 1,
                    type: 'dashed'
                },
                crossStyle: {
                    color: '#1e90ff',
                    width: 1,
                    type: 'dashed'
                },
                shadowStyle: {
                    color: 'rgba(150,150,150,0.3)',
                    width: 'auto',
                    type: 'default'
                }
          },
          backgroundColor:"#FFF",
          textStyle:{
            fontSize:11,
            paddingLeft:5,
            paddingRight:5,
          },
          formatter:'<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:'+`${true?'rgb(249,98,94)':'#f0f'}`+'>{c0}%</span> </div>'
          //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
          // function(params,ticket,callBack) {
          //     var result = '';
          //     // params.forEach(function (item) {
          //     //     result =  item.name + ":" + item.data;
          //     // });
          //     result = params[0].name + params[0].data
          //     return result;
          // }
        },
        calculable : true,
        xAxis : [
            {   
                axisLine:{
                    lineStyle:{
                        width:1,
                        color:"#CCC"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
                type : 'category',
                boundaryGap : false,
                data : data1
            }
        ],
        yAxis : [
          {
                type : 'value',
                scale: true,
                // name:'(人)',
                axisLine:{
                    lineStyle:{
                        width:0,
                        color:"rgb(160,167,176)"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
                axisLabel: {
                    formatter: '{value} %'
                }
            }
        ],
        series : [
            {
                name:'累计收益',
                type:'line',
                stack: '总量',
                smooth:true,/*线条有弧度*/
                data:data2,
                itemStyle : {  
                    normal : {  
                        color:'#fa063a',  /*#53C6E0*/
                        lineStyle:{  
                            color:'#fa063a'  
                        }  
                    }  
                }, 
            },{
                name:'业绩基准',
                type:'line',
                stack: '业绩',
                smooth:true,/*线条有弧度*/
                data:data3,
                itemStyle : {  
                    normal : {  
                        color:'#23c7e2',  /*#53C6E0*/
                        lineStyle:{  
                            color:'#23c7e2'  
                        }  
                    }  
                },
                // symbolSize:6
            }
        ],
        color:['#fa063a']
    };

  }else{  
    option = {
        // tooltip : {
        //     trigger: 'axis'
        // },
        animation: window.isLess47,

        grid:{
          y:'5%',
        },
        // legend: {
        //     data:['2030TDF','沪深300指数','2030TDF比较基准','目标日期-2030'],
        //     y : 'bottom',
        //     x: 'center',
        //     textStyle:{color:"a1a7b2"}
        // },
        calculable : true,
        xAxis : [
            {   
                axisLine:{
                    lineStyle:{
                        width:1,
                        color:"#CCC"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
                type : 'category',
                boundaryGap : false,
                data : ['2016/7/19','2016/8/19','2016/9/19','2016/10/19','2016/11/19','2016/12/19','2017/1/19']
            }
        ],
        yAxis : [
          {
                type : 'value',
                scale: true,
                // name:'(人)',
                axisLine:{
                    lineStyle:{
                        width:0,
                        color:"rgb(160,167,176)"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
                axisLabel: {
                    formatter: '{value} %'
                }
            }
        ],
        series : [
            {
                name:'2030TDF',
                type:'line',
                stack: '总量',
                smooth:true,/*线条有弧度*/
                data:[120, 132, 101, 134, 90, 230, 210],
                itemStyle : {  
                    normal : {  
                        color:'#fa063a',  /*#53C6E0*/
                        lineStyle:{  
                            color:'#fa063a'  
                        }  
                    }  
                }, 
            }
        ],
        color:['#fa063a']
    };
  }
  return option;
}








function compare(prop){
    // return function(a,b){
    //     var allStartDate = getDateS(a[property]);   
    //     var allEndDate = getDateS(b[property]);
    //     var value1 = allStartDate.getTime()
    //     var value2 = allEndDate.getTime()
    //     return value2 - value1;
    // }
    return function (obj1, obj2) {
      var val1 = obj1[prop];
      var val2 = obj2[prop];
      if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
      }
      if (val1 > val2) {
          return -1;
      } else if (val1 < val2) {
          return 1;
      } else {
          return 0;
      }            
    }
}







// WEBPACK FOOTER //
// ./src/components/fundDetail/CommonComponents.js